module.exports = __webpack_public_path__ + "img/7_29.04bd36ec.png";